"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEvmUtilsConfig = void 0;
exports.CommonEvmUtilsConfig = {
    formatEvmChainId: {
        name: 'formatEvmChainId',
        defaultValue: 'hex',
    },
    formatEvmAddress: {
        name: 'formatEvmAddress',
        defaultValue: 'lowercase',
    },
    defaultEvmApiChain: {
        name: 'defaultEvmApiChain',
        defaultValue: '0x1',
    },
};
//# sourceMappingURL=CommonEvmUtilsConfig.js.map